import React from 'react';
import { Box, Inscription, RoundDoneIcon } from '@common-fe/common-fe';

interface Props {
  employerName: string;
  testId?: string;
}

export const ResumeHeader: React.FC<Props> = ({ employerName, testId = 'ResumeHeader' }) => {
  return (
    <>
      <Box align="center" margin={{ top: 'spacing24', bottom: 'spacing12' }} data-testid={`${testId}_icon-container`}>
        <RoundDoneIcon />
      </Box>

      <Box align="center" margin={{ bottom: 'spacing12' }}>
        <Inscription textAlign="center" lineHeight="32px" weight="bold" size="2xl" data-testid={`${testId}_title`}>
          Reactivating {employerName}
        </Inscription>
      </Box>

      <Box align="center" margin={{ bottom: 'spacing12' }}>
        <Inscription textAlign="center" data-testid={`${testId}_description`}>
          {employerName} and any selected plans are being reactivated using their previous settings.
          See the additional steps below to complete setup.
        </Inscription>
      </Box>
    </>
  );
};
